import React, { useEffect, useState, useMemo } from 'react';
import styles from "./PersonLookup.module.scss";
import {ReactComponent as Closer} from './../assets/close.svg';

function shouldFormatDOB(dob) {
    const dashCount = (dob.match(/-/g) || []).length;
    const slashCount = (dob.match(/\//g) || []).length;
    const digitsOnly = dob.replace(/[^0-9]/g, '');
    // Format if it has 2+ separators OR is all digits and exactly 8 characters
    return (dashCount + slashCount) >= 2 || digitsOnly.length === 8;
}

function formatDOB(dob) {
  if (!dob) return '';

  const hasSeparators = /[-\/]/.test(dob);
  let mm, dd, yyyy;

  if (hasSeparators) {
    const parts = dob.split(/[-\/]/);
    if (parts.length !== 3) return '';
    [mm, dd, yyyy] = parts;
  } else {
    const digits = dob.replace(/[^0-9]/g, '');
    if (digits.length !== 8) return '';

    const firstFour = parseInt(digits.slice(0, 4), 10);
    const currentYear = new Date().getFullYear();

    if (firstFour >= 1890 && firstFour <= currentYear) {
      // YYYYMMDD
      yyyy = digits.slice(0, 4);
      mm = digits.slice(4, 6);
      dd = digits.slice(6, 8);
    } else {
      // Assume MMDDYYYY
      mm = digits.slice(0, 2);
      dd = digits.slice(2, 4);
      yyyy = digits.slice(4, 8);
    }
  }

  mm = mm.padStart(2, '0');
  dd = dd.padStart(2, '0');
  if (yyyy.length !== 4) return '';

  return `${mm}-${dd}-${yyyy}`;
}



// Helper to format and compare DOBs (assuming YYYY-MM-DD format)
// const normalizeDOB = (dob) => dob.replace(/[^0-9]/g, '').slice(0, 8);
const normalizeDOB = (dob) => {
    // Remove non-numeric characters
    const digits = dob.replace(/[^0-9]/g, '');
    // If the input is MM-DD-YYYY, digits will be MMDDYYYY (8 digits)
    if (digits.length !== 8) return '';
    // Optionally, return as MMDDYYYY or as a standard format for comparison
    return digits; // MMDDYYYY
  };
  
function PersonLookup({ people, globals, onPersonSelected, onAddPerson }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dob, setDob] = useState('');
  const [showAdd, setShowAdd] = useState(false);

  // Only consider people with the current PracticeID
  const filteredPeople = useMemo(() => {
    return people.filter(
      (p) =>
        p.PracticeID === globals.practiceid &&
        (!firstName || p.FirstName.toLowerCase().startsWith(firstName.toLowerCase())) &&
        (!lastName || p.LastName.toLowerCase().startsWith(lastName.toLowerCase()))
    );
  }, [people, globals.practiceid, firstName, lastName]);

  // Only show results if DOB is fully entered (assuming YYYY-MM-DD)
  const showResults =
    formatDOB(dob).length === 10 ||
    firstName.trim().length >= 2 ||
    lastName.trim().length >= 2;

  useEffect(() => {
      const formattedDOB = formatDOB(dob);
      if (formattedDOB.length === 10 && formattedDOB !== dob) {
        setDob(formattedDOB);
      }
    }, [dob]);

  // Find matching people
  const matchingPeople = useMemo(() => {
    //console.log('useMemo fired', { showResults, people, firstName, lastName, dob });
    if (!showResults) return [];

    // Always filter by PracticeID
    let results = people.filter(
      (p) => ''+p.PracticeID === globals.practiceid
    );
    const formattedDOB = formatDOB(dob);
    // If DOB is filled in, filter by DOB (and optionally by names)
    if (formattedDOB.length === 10) {
      results = results.filter(
        (p) => normalizeDOB(p.DOB) === normalizeDOB(formattedDOB)
      );
      //if (formatDOB !== dob) setDob(formattedDOB);
      // Optionally, still filter by name if user typed them
      if (firstName.trim()) {
        results = results.filter((p) =>
          p.FirstName.toLowerCase().startsWith(firstName.trim().toLowerCase())
        );
      }
      if (lastName.trim()) {
        results = results.filter((p) =>
          p.LastName.toLowerCase().startsWith(lastName.trim().toLowerCase())
        );
      }
      return results;
    }

    // If only name(s) are filled
    if (firstName.trim()) {
      results = results.filter((p) =>
        p.FirstName.toLowerCase().startsWith(firstName.trim().toLowerCase())
      );
    }
    if (lastName.trim()) {
      results = results.filter((p) =>
        p.LastName.toLowerCase().startsWith(lastName.trim().toLowerCase())
      );
    }
    return results;
  }, [people, globals.practiceid, firstName, lastName, dob, showResults]);

  const dummy = (p) => {}

  const onClose = (e) => {
    const cb = onPersonSelected || dummy;
    const newPerson = {
        FirstName: firstName.trim(),
        LastName: lastName.trim(),
        DOB: dob,
        PracticeID: globals.practiceid,
      };
    cb(newPerson);
}

  const handleSelect = (person) => {
    onPersonSelected(person);
    setFirstName('');
    setLastName('');
    setDob('');
    setShowAdd(false);
  };

  const handleAdd = () => {
    const newPerson = {
      FirstName: firstName.trim(),
      LastName: lastName.trim(),
      DOB: dob,
      PracticeID: globals.practiceid,
    };
    onAddPerson(newPerson);
    onPersonSelected(newPerson);
    setShowAdd(false);
    setFirstName('');
    setLastName('');
    setDob('');
  };

  return (
    <div>
      {/*}
        <div className={styles.detail} style={{backgroundColor:"white"}}>
                        <div className={styles.outer}>
                            <div className={styles.inner}>
                                <div className={styles.detailheader}>
                                    <div>Person Search</div>
                                    <div className={styles.headerright} onClick={onClose}><Closer /></div>
                                </div>
      {*/}
        <div className={styles.formctrl}>
        <div className={styles.formlabel}>Date of birth:</div><div className={styles.req}>*</div>
          <input className={styles.forminputreq}
            value={dob}
            onChange={e => setDob(e.target.value)}
            placeholder="MM-DD-YYYY"
            maxLength={10}
            autoComplete="off"
          />
        
      </div>
      <div className={styles.formctrl}>
      <div className={styles.formlabel}>Patient Name, First:</div><div className={styles.req}>*</div>
          
          <input className={styles.forminputreq}
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
            autoComplete="off"
          />
        
      </div>
      <div className={styles.formctrl}>
      <div className={styles.formlabel}>Last:</div><div className={styles.req}>*</div>
          
          <input className={styles.forminputreq}
            value={lastName}
            onChange={e => setLastName(e.target.value)}
            autoComplete="off"
          />
        
      </div>

      {showResults && (
        <div className={styles.formctrl} style={{ marginTop: 16 }}>
          {matchingPeople.length > 0 ? (
            <React.Fragment>
            <div className={styles.formlabel}>Select a person:</div>             
              <ul style={{textAlign:"left",marginLeft:"-30px"}}>
                {matchingPeople.map((p, idx) => (
                  <li key={idx} style={{marginTop:"4px"}}>
                    <button
                      type="button"
                      onClick={() => handleSelect(p)}
                      style={{ cursor: 'pointer', minWidth: "280px", textAlign:"left" }}
                    >
                      {p.FirstName} {p.LastName} ({p.DOB})
                    </button>
                  </li>
                ))}
              </ul>
            
            </React.Fragment>
          ) : (
            <React.Fragment>
            <div className={styles.formctrl}>
              <b>No person found.</b>
              {!showAdd && <button
                type="button"
                onClick={() => setShowAdd(true)}
                style={{ marginLeft: 8 }}
              >
                Add New Person
              </button>}
              </div>
              {showAdd && (
                <div style={{ marginTop: 12, marginLeft: 12 }}>
                  <button type="button" onClick={handleAdd}>
                    Confirm Add: {firstName} {lastName} ({dob})
                  </button>
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    {/*}
    </div>
    </div>
    </div>
    {*/}
    </div>
  );
}

export default PersonLookup;
